import { BaseCall } from '../BaseCall'
import { APIConfig } from '../interfaces'
import type { OAuthProjectWebSummary } from './AdminOAuthProjects'

export class PartnerOAuthProjects extends BaseCall {
	public list = async (): Promise<{ projects: OAuthProjectWebSummary[] }> => {
		const response = await this.client.get<{ projects: OAuthProjectWebSummary[] }>('/partner/oauth-projects', { withCredentials: true })
		return response.data
	}

	public get = async (clientId: string): Promise<{ project: OAuthProjectWebSummary }> => {
		const response = await this.client.get<{ project: OAuthProjectWebSummary }>(`/partner/oauth-projects/${encodeURIComponent(clientId)}`, {
			withCredentials: true
		})
		return response.data
	}

	public update = async (
		clientId: string,
		payload: { name: string; description?: string | null; redirectUris: string[] },
		iconFile?: File
	): Promise<{ project: OAuthProjectWebSummary }> => {
		if (iconFile) {
			const formData = new FormData()
			formData.append('name', payload.name)
			formData.append('description', payload.description ?? '')
			formData.append('redirectUris', JSON.stringify(payload.redirectUris))
			formData.append('icon', iconFile)
			const response = await this.client.patch<{ project: OAuthProjectWebSummary }>(
				`/partner/oauth-projects/${encodeURIComponent(clientId)}`,
				formData,
				{ withCredentials: true }
			)
			return response.data
		}

		const response = await this.client.patch<{ project: OAuthProjectWebSummary }>(
			`/partner/oauth-projects/${encodeURIComponent(clientId)}`,
			payload,
			{ withCredentials: true }
		)
		return response.data
	}

	public regenerateSecret = async (clientId: string): Promise<{ clientSecret: string }> => {
		const response = await this.client.post<{ clientSecret: string }>(
			`/partner/oauth-projects/${encodeURIComponent(clientId)}/regenerate-secret`,
			{},
			{ withCredentials: true }
		)
		return response.data
	}

	public setConfig(config: APIConfig): void {
		this.setBaseUrl(config.API_SERVER)
	}
}
